export const getFullName = (params: {
  firstName?: string;
  lastName?: string;
}): string => {
  const { firstName, lastName } = params;
  return [firstName, lastName].filter(Boolean).join(" ");
};
